import { Text, useSx, View } from 'dripsy';
import React, { useState, useRef } from 'react';
import { CameraType, CameraView as Camera, useCameraPermissions } from 'expo-camera';
import { Button } from '../button';
import { I18Text } from 'app/provider/i18-provider';
import { ViewStyle } from 'react-native';

interface CameraViewProps {
  styles?: ViewStyle
  onChange: (e: any) => void
  onCancel: () => void
  showCamera: boolean
  mainModalView?: { height: number, width: number },
  setImages: (e: any) => void
}

export function CameraView({
  styles = {},
  onChange,
  onCancel,
  showCamera,
}: CameraViewProps) {
  const cameraRef = useRef<any>(null);
  const sx = useSx();
  const [image, setImage] = useState({});
  const [type] = useState<CameraType>('back');
  const [permission, requestPermission] = useCameraPermissions();

  if (!permission) {
    // Camera permissions are still loading
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <Text style={sx({ color: '$primary' })}>Loading...</Text>
      </View>
    );
  }

  if (!permission.granted) {
    // Camera permissions are not granted yet
    return (
      <View style={[
        sx({
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          marginTop: 2,
        }),
      ]}>
        <I18Text
          style={sx({
            color: '$primary',
            fontSize: 18,
            marginBottom: 2,
          })}
        >
          Please allow access to your camera
        </I18Text>
        <Button
          onPress={requestPermission}
          style={{
            minWidth: 100,
            height: 25
          }}
        >
          <I18Text>Grant Permission</I18Text>
        </Button>
      </View>
    );
  }

  return (
    <View style={sx({ flex: 1, height:['100%',200], width: '100%', backgroundColor: 'transparent' })}>
      <Camera
        ref={cameraRef}
        style={[
          sx({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 200,
            minWidth: '100%',
            marginBottom: 5
          })
        ]}
        facing={type}
      >
      </Camera>
      <View style={{ flexDirection: 'row',justifyContent:'center' }}>
        <Button
          onPress={async () => {                    
            if (Object.keys(image).length === 0) {
              if (cameraRef.current) {
                const photo = await cameraRef.current.takePictureAsync({ base64: true });
                if (photo) {
                  await cameraRef.current.pausePreview();
                }
                setImage(photo);
              }
            } else {               
              onChange(image);
              onCancel();
              setImage({});
            }
          }}
          style={{
            minWidth: 100,
            height: 25
          }}
        >
          <I18Text onlyString >
            {Object.keys(image).length === 0 ? 'Capture' : 'Done'}
          </I18Text>
        </Button>
        <Button
          onPress={async() => { 
            await cameraRef.current.resumePreview();
            setImage({}); 
            onCancel(); 
          }}
          style={{
            minWidth: 100,
            height: 25
          }}
        >
          <I18Text>
            {'Cancel'}
          </I18Text>
        </Button>
      </View>
    </View>
  );
}
